import get from 'lodash/get';
import isNil from 'lodash/isNil';
import orderBy from 'lodash/orderBy';

export const groupNLargestBy = <T>(
  data: T[],
  count = 5,
  criterion: string | ((item: T) => number)
): T[] => {
  return orderBy(data, criterion, 'desc')
    .slice(0, count)
    .filter((d) => {
      if (typeof criterion === 'string') {
        return !isNil(get(d, criterion));
      }
      return !isNil(criterion(d));
    });
};
